var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-text-container d-flex align-center pa-1 pr-2",class:`${ _vm.type }--text text--${ _vm.themeCss }`},[_c('div',{staticClass:"alert-text-bg rounded-lg",class:_vm.type}),_c('v-icon',{staticClass:"ma-1 mr-2",attrs:{"color":`${ _vm.type } ${ _vm.themeCss }`,"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }